export default "__VITE_ASSET__BYqmSF2J__"